module.exports = __webpack_public_path__ + "static/img/top.030d598f.png";